// TODO: Load second and third slides via ajax
if (DESKTOP) {
    var $categorySlider = $('.js-articles-default-slider');

    if ($categorySlider.length) {
        $('.js-articles-default-slider-prev, .js-articles-default-slider-next').on('click', function () {
            return false;
        });

        $('.js-articles-default-slider-prev').on('click', function () {
            $(this).closest('.js-articles-default').find('.js-articles-default-slider').slick('slickPrev');
        });

        $('.js-articles-default-slider-next').on('click', function () {
            var slider = $(this).closest('.js-articles-default').find('.js-articles-default-slider');
            if (slider.data('js-loaded')) {
                slider.slick('slickNext');
            } else {
                $.get(slider.data('load-path'), function (data) {
                    slider.slick('slickAdd', data.template);
                    slider.data('js-loaded', true);
                    slider.slick('slickNext');
                });
            }
        });

        $categorySlider
            .on('init', function (event, slick) {
                $(event.target).removeClass('is-cropped');
            })
            .on('afterChange', function (event, slick, currentSlide) {
                if (currentSlide === 0) {
                    $(event.target).closest('.js-articles-default').find('.js-articles-default-slider-prev').addClass('is-disabled');
                } else if (slick.slideCount == currentSlide + 1) {
                    $(event.target).closest('.js-articles-default').find('.js-articles-default-slider-next').addClass('is-disabled');
                } else {
                    $(event.target).closest('.js-articles-default').find('.js-articles-default-slider-prev, .js-articles-default-slider-next').removeClass('is-disabled');
                }
            })
            .slick({
                arrows: false,
                infinite: false,
                speed: 200
            });
    }
}